import { Injectable } from '@angular/core';
import { EmployeeFunctionGroup } from 'src/app/_model/employee-function-group';
import { Resetable } from '../../resetter/resetable';

@Injectable()
export abstract class EmployeeFunctionGroupsDaoService implements Resetable {
  public abstract saveEmployeeFunctionGroups(entries: EmployeeFunctionGroup[]): Promise<void>;
  public abstract createEmployeeFunctionGroup(entry: EmployeeFunctionGroup): Promise<EmployeeFunctionGroup>;
  public abstract getEmployeeFunctionGroups(): Promise<EmployeeFunctionGroup[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
